import { html } from "../../../../.."
import { HookTableFn, HookTableFn_Type } from "../../../../../global/hooks"
import { DialogClose } from "../../../../dialog/dialogapi"
import { FieldSetVal, FieldVal, SYSField } from "../../../../forms/fieldapi"
import {
  FormIsDirty,
  FormIsValid,
  FormSetUnDirty,
} from "../../../../forms/formapi"
import { SYSFormElement } from "../../../../forms/sysformelement"
import { SYSTableDef, TableGet, TableRebuild } from "../../../tableapi"
import { _SetRangeFilter } from "../helpers"

export class SYSHeaderMenuRangeFilter extends SYSFormElement {
  instance: string
  showFilterType: boolean
  async init() {
    this.formType = "SYSHeaderMenuFilter"
    this.formId = this.instance
    await super.init()
  }

  filterOnEnter = async (
    e: KeyboardEvent,
    valueField: SYSField,
    value2Field: SYSField,
    filterTypeField: SYSField,
    def: SYSTableDef
  ) => {
    //@ts-ignore
    if (e.key === "Enter") {
      setTimeout(async () => {
        let validFilterSelected =
          FormIsValid(this.formState) && FormIsDirty(this.formState)
        if (validFilterSelected) {
          let key = FieldVal(filterTypeField)
          await _SetRangeFilter(this.formState, def)
          await FormSetUnDirty(this.formState)
          DialogClose("SYSTableHeaderMenu", { instance: this.formState.formId })
        }
      }, 200)
    }
  }

  async getUI() {
    let tableDef
    if (this.formState.formId === "1") {
      tableDef = TableGet(
        this.state.ovl.libState.tableRowHeaderMenu.tableDefId1
      )
    } else {
      tableDef = TableGet(
        this.state.ovl.libState.tableRowHeaderMenu.tableDefId2
      )
    }
    let def = tableDef.def
    if (!def.uiState.headerSelected) {
      return null
    }

    let filterTypeField = this.formState.fields["HeaderMenuRangeFilterType"]

    let filterTypeValue = FieldVal(filterTypeField)
    let valueField = this.formState.fields["HeaderMenuRangeFilterValue"]
    let value2Field = this.formState.fields["HeaderMenuRangeFilterValue2"]
    let filterType
    let value
    let value2

    let columnRangeFilterDef =
      def.columns[def.uiState.headerSelected].filter.rangeFilter

    if (
      !columnRangeFilterDef.defaultFilterType ||
      (columnRangeFilterDef.defaultFilterType !== filterTypeValue &&
        filterTypeValue !== "none") ||
      this.showFilterType
    ) {
      filterType = html`<ovl-option
        .props=${() => filterTypeField}
      ></ovl-option>`
    }

    let validFilterSelected =
      FormIsValid(this.formState) && FormIsDirty(this.formState)

    switch (valueField.type) {
      case "int":
      case "decimal":
      case "text":
        value = html`<ovl-textbox .props=${() => valueField}></ovl-textbox>`
        value2 = html`<ovl-textbox .props=${() => value2Field}></ovl-textbox>`
        break
      case "date":
        value = html`<ovl-datebox .props=${() => valueField}></ovl-datebox>`
        value2 = html`<ovl-datebox .props=${() => value2Field}></ovl-datebox>`
        break
      case "datetime":
        value = html`<ovl-datetimebox
          .props=${() => valueField}
        ></ovl-datetimebox>`
        value2 = html`<ovl-datetimebox
          .props=${() => value2Field}
        ></ovl-datetimebox>`
        break

      case "time":
        value = html`<ovl-timebox .props=${() => valueField}></ovl-timebox>`
        value2 = html`<ovl-timebox .props=${() => value2Field}></ovl-timebox>`
        break
    }
    value = html`<div
      @keydown=${async (e) => {
        await this.filterOnEnter(
          e,
          valueField,
          value2Field,
          filterTypeField,
          def
        )
      }}
    >
      ${value}
    </div>`

    if (
      filterTypeValue === "greaterThanOrEqual" ||
      (columnRangeFilterDef.defaultFilterType === "greaterThanOrEqual" &&
        filterTypeValue === "none")
    ) {
      value2 = html`<div class="ovl-lt2">&lt;=</div>
        <div
          @keydown=${async (e) => {
            await this.filterOnEnter(
              e,
              valueField,
              value2Field,
              filterTypeField,
              def
            )
          }}
        >
          ${value2}
        </div>`
    } else {
      value2 = undefined
    }
    //}

    let advancedFilterButton
    if (!this.showFilterType && !filterType) {
      advancedFilterButton = html`<button
        class="fd-button"
        @click=${() => {
          this.showFilterType = true
          this.doRender()
          return
        }}
      >
        <i class="sap-icon--overflow"></i>
      </button>`
    }

    let filterButtons
    if (
      FieldVal(filterTypeField) !== "none" ||
      columnRangeFilterDef.defaultFilterType
    ) {
      filterButtons = html`<div
        class="fd-segmented-button"
        role="group"
        aria-label="Tablefilter"
      >
        <button
          class="fd-button ${validFilterSelected
            ? "fd-button--attention is-selected"
            : "ovl-control-disabled"}"
          @click=${async () => {
            await _SetRangeFilter(this.formState, def)
            await FormSetUnDirty(this.formState)
          }}
        >
          <i class="sap-icon--filter"></i>
        </button>
        <button
          class="fd-button"
          ?disabled=${FieldVal(filterTypeField) === "none"}
          @click=${async () => {
            //await FieldSetVal(filterTypeField, "none")
            await _SetRangeFilter(this.formState, def, true)
            await FormSetUnDirty(this.formState)
          }}
        >
          <i class="sap-icon--clear-filter"></i>
        </button>
        ${advancedFilterButton}
      </div>`
    }

    return html`
      <div class="ovl-headermenufilter-details">
        ${filterType}
        <div class="ovl-rangefiltervalues">
          ${value}${value2}${filterButtons}
        </div>
      </div>
    `
  }
}
